import { render, staticRenderFns } from "./ListCommercia.vue?vue&type=template&id=6508bc7f&"
import script from "./ListCommercia.vue?vue&type=script&lang=js&"
export * from "./ListCommercia.vue?vue&type=script&lang=js&"
import style0 from "./ListCommercia.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports